import { type MouseEvent, useCallback } from "react";
import { useDispatch } from "react-redux";
import { trackUnitsInteraction } from "~/app/analytics/ga/ga";
import type { UnitMode } from "~/domains/userPreferences/types/UnitMode";
import { useUnitMode } from "~/domains/userPreferences/hooks/useUnitMode";
import type { GAPageType } from "~/domains/userPreferences/components/UnitModeToggle";
import { changeUnitModeThunk } from "~/domains/userPreferences/redux/userPreferencesSlice";

export const useReduxUnitMode = (page: GAPageType, onChange?: (unitMode: UnitMode) => void) => {
  const value = useUnitMode();
  const dispatch = useDispatch();
  const handleOnChange = useCallback(
    (unitMode: UnitMode) => {
      dispatch(changeUnitModeThunk(unitMode));
      trackUnitsInteraction(page, unitMode);
      onChange?.(unitMode);
    },
    [dispatch, page, onChange],
  );
  const onClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      const unitMode = (e.target as HTMLElement).getAttribute("value")! as UnitMode;
      handleOnChange(unitMode);
    },
    [handleOnChange],
  );
  return {
    value,
    onClick,
    onChange: handleOnChange,
  };
};
